import config from './config';

function cutString(string, limit) {
  if (string.length > limit) {
    string = `${string.substr(0, limit - 3)}...`;
  }
  return string;
}

function getFileNameFromLink(link) {
  const query = link.split('?')[1];
  if (query) {
    return query.split('=')[1];
  }
  return '';
}

const extensionMapping = config.files.extensionMapping;

function getFileTypeFromLink(link) {
  const fileName = getFileNameFromLink(link);
  return getFileTypeFromName(fileName);
}

function getFileTypeFromName(fileName) {
  const a = fileName.split('.');
  if (a.length === 1 || (a[0] === '' && a.length === 2)) {
    return 'file';
  }
  let type = 'file';
  const extension = a.pop();
  for (const fileType in extensionMapping) {
    if (extensionMapping.hasOwnProperty(fileType) && extensionMapping[fileType].includes(extension)) {
      type = fileType;
      break;
    }
  }
  return type;
}

function isFileTypeInList(type, linkList) {
  for (const link of linkList) {
    const fileType = getFileTypeFromLink(link);
    if (fileType === type) {
      return true;
    }
  }
  return false;
}

const processNodeButton = (button) => {
    const hasLink = button.text.includes('||');
    const parts = button.text.split('||');
    const shortText = parts[0];
    const link = hasLink ? parts[1] : '';
    return {...button, hasLink, shortText, link};
}

const HTML_ENTITIES = {amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' '};

/* A message is stored as HTML (bold, italic, links) - this is just what it says. */
function stripHtml(text) {
    if (!text) return '';

    return text
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<(?!(?:first_name|last_name)>)[^>]*>/g, '') // the name placeholders are text
        .replace(/&(#x[0-9a-f]+|#\d+|\w+);/gi, (entity, code) => {
            if (code[0] === '#') {
                const number = code[1].toLowerCase() === 'x' ? parseInt(code.slice(2), 16) : parseInt(code.slice(1), 10);
                return isNaN(number) ? entity : String.fromCharCode(number);
            }
            return HTML_ENTITIES[code.toLowerCase()] || entity;
        });
}

function truncateTextToFit(text, buttonWidth, fontSize = 12) {
    if (!text) return '';

    const avgCharWidth = fontSize * 0.7;

    const maxChars = Math.floor(buttonWidth / avgCharWidth) - 3;

    if (text.length <= maxChars) return text;
    return text.slice(0, maxChars - 1) + '…';
}

export {
  cutString, getFileNameFromLink, getFileTypeFromName, getFileTypeFromLink, isFileTypeInList, processNodeButton,truncateTextToFit, stripHtml
};



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/util.js